// extracted by mini-css-extract-plugin
export var divider = "_dv-7";
export var itemsToggle = "_dv-8";
export var mergeModal = "_dv-1";
export var optionCard = "_dv-4";
export var radioGroup = "_dv-6";
export var radioOption = "_dv-0";
export var selected = "_dv-5";
export var shipmentOptions = "_dv-2";
export var tableOptions = "_dv-3";